module.exports = __webpack_public_path__ + "img/shop_A_3.86440fcc.png";